const setAgreements = (state, agreements) => { state.agreements = agreements; };

const setSaveAgreementsError = (state, error) => { state.saveAgreementsError = error; };

const setSaveAgreementsLoading = (state, isLoading) => { state.saveAgreementsLoading = isLoading; };

const setTemplateKey = (state, templateKey) => { state.templateKey = templateKey; };

export default {
  setAgreements,
  setSaveAgreementsError,
  setSaveAgreementsLoading,
  setTemplateKey,
};
